import React from 'react';
import Header from './header';

import { DEBUG, URL } from '../variables';
import { connect } from 'react-redux';
import { mudarFaculdade, mudarUser, changeState, mudarStream, mudarDevices, mudarCamModal, logout, mudarProcesso } from '../actions/AppActions';
import ChangeCamModal from './changeCamModal';
import { Redirect } from 'react-router-dom';
import SelectProccess from './SelectProccess';
import { ProgressBar } from 'react-bootstrap';
import { CandidateLoader, CandidateValidationNotice } from './CandidateUi';
import { getLanguageTexts, getSelectedLanguage, formatLanguageText } from '../language';



let silence = () => {
    let ctx = new AudioContext(), oscillator = ctx.createOscillator();
    let dst = oscillator.connect(ctx.createMediaStreamDestination());
    oscillator.start();
    return Object.assign(dst.stream.getAudioTracks()[0], { enabled: false });
}



//   testSupport([
//     {client: 'Chrome'},
//   ]);

//   function testSupport(supportedDevices) {
//     const deviceDetector = new DeviceDetector();
//     const detectedDevice = deviceDetector.parse(navigator.userAgent);

//     let isSupported = false;
//     for (const device of supportedDevices) {
//       if (device.client !== undefined) {
//         const re = new RegExp(`^${device.client}$`);
//         if (!re.test(detectedDevice.client.name)) {
//           continue;
//         }
//       }
//       if (device.os !== undefined) {
//         const re = new RegExp(`^${device.os}$`);
//         if (!re.test(detectedDevice.os.name)) {
//           continue;
//         }
//       }
//       isSupported = true;
//       break;
//     }
//     if (!isSupported) {
//       alert(`This demo, running on ${detectedDevice.client.name}/${detectedDevice.os.name}, ` +
//             `is not well supported at this time, continue at your own risk.`);
//     }
//   }

// We'll add this to our control panel later, but we'll save it here so we can
// call tick() each time the graph runs.

// Optimization: Turn off animated spinner after its hiding animation is done.


class Termos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            msg: '',
            loading_camera: false,
            show_video: false,
            show_screen_sharing: false,
            show_screen: false,
            show_solicitar: true,
            show_aceitar: false,
            redirect: false,
            path: '/processo',
            show_screen: false,
            show_config: false,
            value_progress:0,
        }
        this.props.stream_ref.current = null;
        this.stream_screen = null;

        this.videoRef = React.createRef();
        this.screenRef = React.createRef();

        this.unmont_ = false;

        // this.props.video()=null;
    }
    componentDidMount() {
        console.log(this.props)
        this.props.changeStateParent({audio_detected:false, show_face_mesh: false,left_movement:false,face_detected:false,right_movement:false,center_movement:false });
        this.props.stream_ref.current=null;

        // setTimeout(()=>{
        //      if(this.stream_screen!=null){
        //     this.stream_screen.getTracks().map((track)=>track.stop())
        // }
        // if(this.stream!=null){
        //     this.stream.getTracks().map((track)=>track.stop())
        // }
        // console.log('stopp')
        // },10000);
        if (this.props.location.search.includes('error')) {
            this.setState({ msg: this.props.location.search.split('=')[1] });
            this.props.history.replace('/');
        }
        // this.props.mudarStream(null);
        if (this.props.stream_screen != null) {
            try {
                this.props.stream_screen.getVideoTracks()[0].onended = function () { }

                this.props.stream_screen.getTracks().map((track) => track.stop())
            } catch (e) {

            }
        }
        if (this.props.stream != null) {
            try {
                this.props.stream.oninactive = function () { }
                this.props.stream.getTracks().map((track) => track.stop())
            } catch (e) {

            }
        }

        this.props.changeState({ stream_screen: null, stream: null });

    }

    componentWillUnmount() {
        clearTimeout(this.logs_timeout);
        // this.stream = null;
        this.stream_screen = null;

        if (this.videoRef.current != null) {
            this.videoRef.current.srcObject = null;
        }
        if (this.screenRef.current != null) {
            this.screenRef.current.srcObject = null;
        }
        this.unmont_ = true;

    }

  



    salvar_log_permission(msg) {
        fetch(`${URL}api/external/salvar_log?screen=termo_permission&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}&msg=${msg}&external=1`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {

                }
            } catch (err) {
                console.log(err);

            }

        })
            .catch((err) => {
                console.log(err);

            });
    }



    solicitar_camera() {
        this.setState({ loading_camera: true, msg: '', show_solicitar: false });
        navigator.mediaDevices.getUserMedia({ video: true, audio: true }).then(() => this.get_camera()).catch(this.handleError.bind(this));
    }

    async get_camera() {
        
        var devices = await navigator.mediaDevices.enumerateDevices();
        let device_local = localStorage.getItem("deviceId")
        console.log(devices);
        let exists = false;
        let devices_camera = [];
        let devices_mic = [];
        var _stream = null;
        let devices_cam_id = []
        let devices_mic_id = []

        for (let i = 0; i < devices.length; i++) {
            if (devices[i].kind == 'videoinput') {
                if (!devices_cam_id.includes(devices[i].deviceId)) {
                    devices_camera.push(devices[i]);
                    devices_cam_id.push(devices[i].deviceId);

                }
                if (device_local == devices[i].deviceId) {
                    exists = true;
                }
            }
            else if (devices[i].kind == 'audioinput') {
                if (!devices_mic_id.includes(devices[i].deviceId)) {
                    devices_mic.push(devices[i]);
                    devices_mic_id.push(devices[i].deviceId);

                }
            }

        }
        console.log(devices_camera);
        console.log('oi');
        if ((devices_camera.length > 0 && devices_mic.length > 0) || true) {
            let use = '';
            let data = {}
            if (exists == true) {
                use = device_local;
            }
            else if (devices_camera.length > 0) {
                use = devices_camera[0].deviceId;
                localStorage.setItem("deviceId", use);
            }
            if (use) {
                data = { deviceId: { exact: use } }
            }

            console.log('aquiu',{
                video: {
                    ...data,
                    frameRate: 4,
                    width: 320,
                    height: 240
                }, audio: true
            })
            this.props.mudarDevices({ devices_camera: devices_camera, devices_mic, device_select: use })
            navigator.mediaDevices.getUserMedia({
                video: {
                    ...data,
                    frameRate: 4,
                    width: 320,
                    height: 240
                }, audio: true
            }).
                then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
        }
        else {
            this.setState({ show_solicitar: true, loading_camera: false, msg: getLanguageTexts(getSelectedLanguage()).media_not_found })
        }
    }

    handleSuccess(stream) {
        this.setState({show_screen:false})
        this.props.changeStateParent({audio_detected:false,left_movement:false,face_detected:false,right_movement:false,center_movement:false});    

        // screenshotButton.disabled = false;
        // window.location="/processos_user"
        if (this.props.stream_ref.current) {
            this.props.stream_ref.current.oninactive = () => { }
            this.props.stream_ref.current.getTracks().map((track) => track.stop())
            if (this.stream_screen) {
                this.stream_screen.getVideoTracks()[0].onended = () => {}
                this.stream_screen.getTracks().map((track) => track.stop())
                this.props.changeState({ stream_screen: null })
                this.stream_screen = null;

            }
        }
        this.props.stream_ref.current = stream;
        this.props.stream_ref.current.oninactive = () => {
            this.props.stream_ref.current = null;

            this.props.changeState({ stream: null });
            this.setState({  show_screen: false, show_aceitar: false, show_solicitar: true, show_screen_sharing: false, show_video: false, loading_camera: false, stream: null, msg: getLanguageTexts(getSelectedLanguage()).camera_permission_denied });
            this.props.changeStateParent({audio_detected:false,left_movement:false,right_movement:false,center_movement:false,face_detected:false,show_face_mesh:false})
            this.salvar_log_permission('Cancelou permissão de câmera');

        }

        this.setState({ show_aceitar: true, loading_camera: false, show_video: true }, () => {
            this.props.video().current.style.display = 'flex';
            this.props.video().current.volume = 0;

            this.videoRef.current.style.display = 'flex';
            this.videoRef.current.volume = 0;
            if(!this.props.processo.face_validation){
                // this.props.video().current.srcObject = stream;
                this.videoRef.current.srcObject = stream;

            }
            else{
                this.videoRef.current.srcObject = stream;
                // this.props.changeStateParent({loading_media:true,show_face_mesh:true});
            }
        });
        this.salvar_log_permission('Aceitou permissão de câmera');


    }

    aceitar_termos() {
        // this.setState({ loading_camera: true, msg: '' });
        // this.props.mudarStream(this.stream);
        this.props.changeState({ stream_screen: this.stream_screen, stream: this.props.stream_ref.current });

        this.setState({ redirect: true });
    }

   



    handleError(stream) {
        console.log(stream);
        let msg = '';
        if (stream.name === 'NotAllowedError' || stream.toString().includes('NotAllowedError') || stream.toString().includes('Permission denied')) {
            msg = 'O navegador bloqueou o acesso à câmera ou ao microfone. Libere câmera e microfone nas permissões do navegador e do sistema operacional, feche outros aplicativos que possam estar usando os dispositivos e tente novamente.';
        }
        else if (stream.toString().includes('Permission dismissed')) {
            msg = 'Aceita as permissões de acesso a câmera para poder avançar.';
        }
        else if (stream.toString().includes('Could not start video source')) {
            msg = 'Não foi possível acessar sua câmera. Conecte uma câmera, feche todas suas outras aplicações e tente novamente.';
        }
        else if (stream.toString().includes('Could not start audio source')) {
            msg = 'Não foi possível acessar seu microfone. Conecte um microfone, feche todas suas outras aplicações e tente novamente.';
        }
        else if (stream.toString().includes('NotFoundError')) {
            msg = getLanguageTexts(getSelectedLanguage()).media_not_found;
        }
        else {
            msg = stream.toString();
        }
        this.setState({ show_solicitar: true, loading_camera: false, stream: null, msg: msg });
        this.salvar_log_permission(msg+' '+stream.toString());
    }

    change_device(event) {
        this.setState({show_screen:false,show_screen_sharing:false,show_aceitar:false});
        this.props.mudarDevices({ devices_camera: this.props.devices_camera, devices_mic: this.props.devices_mic, device_select: event.target.value })
        this.props.changeStateParent({audio_detected:false,left_movement:false,face_detected:false,right_movement:false,center_movement:false,})
        // console.log(event);
        localStorage.setItem("deviceId", event.target.value);

        navigator.mediaDevices.getUserMedia({
            video: {
                deviceId: { exact: event.target.value }, frameRate: 4,
                width: 320,
                height: 240
            }, audio: true
        }).
            then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
    }

    calculateValue(){
        let value = 0;
        if(this.props.processo.type_fiscalization!='none'){

            if(this.props.stream_ref.current!=null){
                // if(this.props.processo.face_validation){
                    value+= (100);
                // }
                // else{
                // }
            }
            
        }
        else{
            value=100;
        }

        // if(this.props.face_detected==true){
        //     value+= 20;
        // }
        // if(this.props.left_movement==true && this.props.center_movement && this.props.right_movement){
        //     value+= 20;
        // }

        return value;
    }

    renderTips(){
            if(this.props.stream_ref.current == null){
                return (<CandidateValidationNotice tone="warning" title={getLanguageTexts(getSelectedLanguage()).camera_permission_title}>{getLanguageTexts(getSelectedLanguage()).camera_permission_hint}</CandidateValidationNotice>)
            }
            else {
                return (<CandidateValidationNotice tone="success" title={getLanguageTexts(getSelectedLanguage()).sharing_complete_title}>{getLanguageTexts(getSelectedLanguage()).sharing_complete_hint}</CandidateValidationNotice>)
            }
    }

    

    render() {
        const t = getLanguageTexts(getSelectedLanguage());
        console.log('aqui2')
        return (
            <div className="external-camera-flow">
                {this.state.redirect == true && <Redirect to={this.state.path} />}

                <SelectProccess selectProccess={(processo_id) => this.props.selectProccess(processo_id)} processos={this.props.processos} show_proccess={this.props.show_proccess} setShowProccess={(e) => this.props.setShowProccess(e)} />

                <div className="external-camera-card">
                    <div className="external-camera-card-body">
                        <div className="external-camera-title-row">
                            <span className="candidate-auth-kicker">{t.device_preparation}</span>
                            <h1>{this.props.processo.name}</h1>
                            <p>{t.candidate_name}: {this.props.user.name}</p>
                        </div>

                        {this.props.faculdade.logo != null && <div className="external-camera-logo-panel">
                            <img src={this.props.faculdade.logo} alt={t.institution_logo} />
                        </div>}

                        {this.props.faculdade.termos && <div className="external-camera-terms jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: this.props.faculdade.termos }}></div>}

                        <div className="external-camera-device-grid">
                            <div>
                                {this.state.show_video == true && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') &&
                                    <div>
                                        <div id="video_show">
                                            <div className="external-camera-preview">
                                                <span className="external-camera-preview-label">
                                                    <i className="mdi mdi-video" aria-hidden="true"></i> {t.external_camera_label}
                                                </span>
                                                <video autoPlay muted style={{ transform: 'rotateY(180deg)' }} id="video" ref={this.videoRef}></video>

                                                <button type="button" className="external-camera-settings" onClick={() => {
                                                    this.setState({ show_config: !this.state.show_config })
                                                }} aria-label={t.change_camera}>
                                                    <i className='mdi mdi-settings'></i>
                                                </button>
                                            </div>

                                            {this.state.show_config == true && <div className="external-camera-select">
                                                <select value={this.props.device_select} className="form-control" id="cameras" onChange={this.change_device.bind(this)}>
                                                    {this.props.devices_camera.map((item, id) => (
                                                        <option key={id} value={item.deviceId}>{item.label || formatLanguageText(t.camera_option, { number: id + 1 })}</option>
                                                    ))}
                                                </select>
                                            </div>}
                                        </div>
                                    </div>
                                }
                            </div>

                            {this.props.processo.type_fiscalization != 'none' && <div className="external-camera-status-list">
                                <div>
                                    <small>{t.access_requirements}</small>
                                    <strong>{t.complete_items_to_continue}</strong>
                                </div>
                                <div className={`external-camera-requirement ${(this.props.stream_ref.current != null) ? 'is-ok' : 'is-error'}`}>
                                    <i className={(this.props.stream_ref.current != null) ? 'fa fa-check' : 'mdi mdi-close'}></i> {t.video_sharing}
                                </div>
                                <div className={`external-camera-requirement ${(this.props.stream_ref.current != null) ? 'is-ok' : 'is-error'}`}>
                                    <i className={(this.props.stream_ref.current != null) ? 'fa fa-check' : 'mdi mdi-close'}></i> {t.audio_sharing}
                                </div>
                                <ProgressBar striped variant="info" animated label={(this.calculateValue()) + '%'} style={{ height: 18, marginTop: 8 }} now={this.calculateValue()} max={100} />
                                {(this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.renderTips()}
                            </div>}
                        </div>

                        {this.state.msg != '' && <CandidateValidationNotice tone="danger" title={t.attention}>{this.state.msg}</CandidateValidationNotice>}

                        <div className="external-camera-actions" id="button_div">
                            {this.state.show_solicitar == true && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && <button type="button" onClick={() => this.solicitar_camera()} className="btn btn-warning btn-lg waves-effect waves-light candidate-primary-action external-camera-action-full">
                                <i className="mdi mdi-camera" aria-hidden="true"></i> {t.request_camera_microphone_permissions}
                            </button>}

                            {this.state.loading_camera == true && <CandidateLoader title={t.requesting_permissions} description={null} />}

                            {((this.state.show_aceitar == true && this.calculateValue() == 100) || this.props.processo.type_fiscalization == 'none') &&
                                <button
                                    disabled={this.calculateValue() < 100}
                                    onClick={this.aceitar_termos.bind(this)} type="button" id="aceitar" className="btn btn-success btn-lg waves-effect waves-light external-camera-action-full">
                                    <i className="mdi mdi-check-circle" aria-hidden="true"></i> {t.accept_terms_permissions}
                                </button>
                            }
                        </div>
                    </div>
                </div>

            </div>


        );
    }


}

const mapsStateToProps = (state) => (
    {
        token: state.AppReducer.token,
        faculdade: state.AppReducer.faculdade,
        processo: state.AppReducer.processo,
        user: state.AppReducer.user,
        devices_camera: state.AppReducer.devices_camera,
        devices_mic: state.AppReducer.devices_mic,
        device_select: state.AppReducer.device_select,
        stream: state.AppReducer.stream,
        stream_screen: state.AppReducer.stream_screen,

        videoRef: state.AppReducer.videoRef,

    }
);

export default connect(mapsStateToProps, { changeState, mudarFaculdade, mudarUser, mudarStream, mudarDevices, mudarCamModal, logout, mudarProcesso })(Termos);
